import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import axios from "axios";
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from "react-redux";
import ErrorModal from "../Security/ErrorModal";
import { Endpoints } from "../../Global/Endpoints";
import ChatBotWindow from "../ChatBot/ChatBotWindow";
import { useChat } from '../Layout/ChatContext';

export const RX_Review = () => {
    const { t, i18n } = useTranslation();
    const [reviewData, setReviewData] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [homeQty, setHomeQty] = useState("");
    const userInfo = useSelector((state) => state.userData);
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [selectedPharmacy, setSelectedPharmacy] = useState("");
    const [selectedPharmacyCode, setSelectedPharmacyCode] = useState("");
    const [OrderType, setOrderType] = useState("");
    const [showConfirmButtons, setShowConfirmButtons] = useState(false);
    const [cheapestPharmacy, setCheapestPharmacy] = useState("");
    const [cheapestPharmaCode, setCheapestPharmaCode] = useState("");
    const [showNurseModal, setShowNurseModal] = useState(false);
    const {isChatVisible, toggleChat, showChat } = useChat();

    const ssoData = useSelector((state) => state.sso.ssoUserData);
    const isHighmarkPortal = ssoData?.Portal === "Highmark";

    const location = useLocation();
    const navigate = useNavigate();
    const authNo = location.state?.authorizationDetail?.AuthNo;
    const initialPharmacyName = location.state?.authorizationDetail?.PharmacyName;
    const initialPharmacyCode=location.state?.authorizationDetail?.PharmacyID;
    
    const authorizationDetail = location.state?.authorizationDetail;

    console.log(authorizationDetail)
   
      useEffect(() => {
        const fetchReviewRXData = async () => {
          try {
            const params = {
              MemberID: userInfo.userData.MemberID,
              Contract: userInfo.userData.ContractIdentified,
              AuthNo: authNo,
              EmailID: userInfo.userData.EmailID,
              DeviceType: "PatientPortal",
            };
      
            const response = await axios.post(
              Endpoints.LoadReviewRX,
              { _Params: JSON.stringify(params) },
              {
                //params: { _params: JSON.stringify(params) },
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                  "Authorization": `Bearer ${localStorage.getItem('AccessToken')}`,
                }
              }
            );
      
            if (response.data) {
              setReviewData(response.data);
              setOrderType(response.data.OrderType);
              console.log("Review RX Data:", response.data);
            } else {
              console.error("Unexpected response structure:", response.data);
            }
          } catch (error) {
            console.error("Error fetching Review RX data:", error);
          }
        };
      
        fetchReviewRXData();
      }, [authNo,initialPharmacyName, userInfo.userData.MemberID, userInfo.userData.ContractIdentified]);

      const formatUSPhoneNumber = (phoneNumber) => {
        // Remove all non-numeric characters
        const cleaned = ('' + phoneNumber).replace(/\D/g, '');
      
        // Check if the number is valid and has 10 digits
        if (cleaned.length === 10) {
          return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
        }
      
        // Return the original phone number if it doesn't have 10 digits
        return phoneNumber;
      };
    // Function to handle back navigation
  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };
  
  // Function to handle refill button click
  const handleRefillClick = () => {
    navigate('/refills-required', { state: { authorizationDetail: authorizationDetail } });
};

    return(
        <>

{isHighmarkPortal ? 
          <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
              <span>
              <i className="bi bi-chevron-left"></i>
              </span>
          </button>       
          <h2 className="page-heading">{t('rxReview')}</h2>
          </div>:
          <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
              <span>
              <i className="bi bi-chevron-left"></i>    
              {t('Back')}        
              </span>
          </button>       
          <h2 className="page-heading">{t('rxReview')}</h2>
          </div>
      }

            {/* <div className="col-12 mt-4 inner-page-heading-wrapper">
                <button onClick={handleBackClick} className="win-back-btn"><span><i class='bi bi-chevron-left'></i>{t('Back')}</span></button>
                <h2 className="page-heading">{t('rxReview')}</h2>
            </div> */}

            <div className="col-md-12 mt-2">
                <div>
                <p>
                {t('authorizationNumber')}: <b>{authorizationDetail?.AuthNo || t('nA')}</b>
          </p>
          <p>
          {t('duration')}: <b>({authorizationDetail?.AuthRange || t('nA')})</b>
          </p>
          <p>
          {t('pharmacy')}: <b>{authorizationDetail?.PharmacyName || t('nA')}</b>
          </p>
                </div>

                <div>
                <p className="text-logo-color">{t('pleaseCallPharmacy')} 
                  <span> {authorizationDetail?.PharmacyPhone
    ? formatUSPhoneNumber(authorizationDetail.PharmacyPhone)
    : t('nA')} </span>
  {t('toTrackOrder')}</p>
                </div>
     {/* Conditionally render refill button */}
     {authorizationDetail?.RefillsAvailable === "Yes" && (
  <button onClick={handleRefillClick} className="win-btn-primary">
    {t('requestRefill')}
  </button>
)}
                <div className="mt-2">
                {reviewData?.Rx?.map((medication, index) => (
                <div key={index} className="medication-item">
                    {/* Render the details of each medication */}
                    
                    <b>{medication.DrugName || t('medicationDetailsNotAvailable')}</b>
                    
                    {/* Add more details about the medication if needed */}
                    {/* <p>{"---------------------------------------------"}</p> */}
                </div>
                ))}
                </div>
            </div>
            {/* {isChatVisible && <ChatBotWindow />} */}
        </>
    )
}

export default RX_Review;